import type { Messages } from './en';

/**
 * Xerrades rotatives. Cada personatge té salutacions segons l’hora del dia i
 * diversos temes; cada tema ofereix tres respostes (afectuosa, curiosa, juganera).
 */
export const caTalks: Messages['talks'] = {
  chat: '💬 Xerrar',
  emma: {
    greet: {
      morning: ['Bon dia! Has dormit bé?', 'Bon dia! Avui he portat llet de maduixa.'],
      afternoon: ['Ei! Com ha anat la classe?', 'Hola! Que no fa una tarda preciosa?'],
      evening: ['Oh, hola! Me’n vaig a casa d’aquí a una estona.', 'Avui la posta de sol és superbonica!'],
    },
    topics: [
      {
        say: 'Estic aprenent una cançó nova en anglès. T’agrada la música?',
        choices: [
          { t: 'M’encanta la música! Me la cantes?', reply: 'D’acord, només la tornada… la la la! Ha ha, no riguis!' },
          { t: 'De què va la cançó?', reply: 'Va de ser valent encara que et sentis petit. M’agrada molt.' },
          { t: 'Només si també balles!', reply: 'Ha ha! Va, però tu has de ballar amb mi!' },
        ],
      },
      {
        say: 'Si poguessis viatjar a qualsevol lloc, on aniries?',
        choices: [
          { t: 'A algun lloc amb tu i els amics!', reply: 'Ooh, és la millor resposta. Doncs una excursió de classe!' },
          { t: 'I TU, on aniries?', reply: 'A Kyoto, a veure els temples. O als Alps, per la neu!' },
          { t: 'A la lluna. Evidentment.', reply: 'Ha ha! Porta berenar. Molt de berenar.' },
        ],
      },
      {
        say: 'He tret una nota més baixa del que esperava a l’examen de mates…',
        choices: [
          { t: 'T’hi has esforçat molt. Això és el que compta.', reply: 'Gràcies… Tens raó. Preguntaré a la professora les parts que m’han sortit malament.' },
          { t: 'Quina part t’ha costat? Podem estudiar junts.', reply: 'Les fraccions! Uf. D’acord, quedem per estudiar a la biblioteca?' },
          { t: 'Les mates només són números fent drama.', reply: 'Ha ha ha! De debò, m’has animat.' },
        ],
      },
      {
        say: 'Aquest matí la meva gata m’ha tirat els deures de la taula.',
        choices: [
          { t: 'Oh, no! Estan bé?', reply: 'Una mica arrugats, però bé. Això sí, la gata semblava molt orgullosa.' },
          { t: 'Com es diu la teva gata?', reply: 'Pudding! És taronja i molt rodoneta.' },
          { t: 'La teva gata et volia ajudar amb els deures.', reply: 'Ha ha, però és fatal en anglès.' },
        ],
      },
    ],
  },
  rain: {
    greet: {
      morning: ['Bon dia! Ja vaig pel capítol cinc.', 'Hola! Vols que et deixi un llibre?'],
      afternoon: ['Xxt, veu de biblioteca! Hola!', 'Oh, ets tu! Arribes en el moment perfecte.'],
      evening: ['M’he tornat a quedar fins tard llegint.', 'Una pàgina més… bé, deu pàgines més.'],
    },
    topics: [
      {
        say: 'Estic llegint una novel·la de misteri. Crec que ja sé qui ha estat!',
        choices: [
          { t: 'No m’ho diguis! Jo també el vull llegir.', reply: 'Muts i a la gàbia. Te’l deixaré quan l’acabi.' },
          { t: 'Quines pistes has trobat?', reply: 'Una sabata plena de fang i un paraigua desaparegut. Molt sospitós.' },
          { t: 'Ha estat el majordom. Sempre és el majordom.', reply: 'Ha ha! Si en aquesta història ni tan sols hi ha majordom!' },
        ],
      },
      {
        say: 'De vegades em poso nerviosa quan parlo a classe.',
        choices: [
          { t: 'Li passa a molta gent. No estàs sola.', reply: 'De veritat? Això m’ajuda. Potser demà provaré d’aixecar la mà un cop.' },
          { t: 'Què és el que et fa por?', reply: 'Que tothom em miri. Però practicar amb tu m’ajuda.' },
          { t: 'Imagina’t que tothom és una patata.', reply: 'Patates… d’acord, és una bajanada, però potser funciona!' },
        ],
      },
      {
        say: 'Què prefereixes: còmics o novel·les?',
        choices: [
          { t: 'Tots dos! Una història és una història.', reply: 'Exacte! Les bones històries són bones històries.' },
          { t: 'Me’n recomanes algun?', reply: 'Prova «La guardiana del far». Va d’una noia que té cura d’un far.' },
          { t: 'Llibres de cuina. M’agraden les fotos.', reply: 'Ha ha! Ara tinc gana.' },
        ],
      },
    ],
  },
  teacher: {
    greet: {
      morning: ['Bon dia. A punt per avui?', 'Bon dia! Recorda beure aigua.'],
      afternoon: ['Hola! Com van les classes?', 'Oh, hola. Dia atrafegat?'],
      evening: ['Encara ets aquí? No t’oblidis d’anar a casa a descansar.', 'Bona feina, avui.'],
    },
    topics: [
      {
        say: 'Ajudar els altres és meravellós, però també t’has de cuidar a tu mateix.',
        choices: [
          { t: 'Ho faré. Gràcies, professora Lin.', reply: 'Molt bé. Descansa, menja bé i demana ajuda quan la necessitis.' },
          { t: 'I vostè, com es cuida?', reply: 'Una tassa de te, un passeig i anar a dormir d’hora. Les coses senzilles funcionen.' },
          { t: 'Em menjaré una galeta de més per la meva salut.', reply: 'Ha ha. Una galeta. I una peça de fruita.' },
        ],
      },
      {
        say: 'La classe 8-3 prepara una venda solidària. Alguna idea?',
        choices: [
          { t: 'Galetes casolanes! Jo sé fer-ne.', reply: 'Quina bona idea. La gent sempre compra coses fetes a casa.' },
          { t: 'Per a què serviran els diners?', reply: 'Per comprar llibres per a l’hospital infantil. Bona causa, oi?' },
          { t: 'Una piscina per tirar-hi els profes?', reply: 'Ni pensar-ho. Però bon intent.' },
        ],
      },
      {
        say: 'Has acabat la lectura d’aquesta setmana?',
        choices: [
          { t: 'Sí! M’ha agradat el final.', reply: 'A mi també. En parlarem a classe.' },
          { t: 'Encara no. És llarga?', reply: 'Vint pàgines. Llegeix-ne una mica cada dia: aquest és el truc.' },
          { t: 'Se la va menjar el meu gat.', reply: 'Hmm, el famós gat que es menja els deures. N’he sentit a parlar.' },
        ],
      },
    ],
  },
  chunbo: {
    greet: {
      morning: ['Bon dia, jovenet!', 'Que d’hora que t’has llevat, eh? Molt bé.'],
      afternoon: ['Bona tarda! T’estàs portant bé?', 'Avui fa calor, eh?'],
      evening: ['Cap a casa? Vés amb compte amb el trànsit.', 'Un altre dia enllestit. Bona feina.'],
    },
    topics: [
      {
        say: 'Quan tenia la teva edat, caminava una hora cada dia per anar a l’escola.',
        choices: [
          { t: 'Uau, és increïble!', reply: 'I m’encantava! Cada matí veia arrossars i búfals.' },
          { t: 'Com era l’escola en aquella època?', reply: 'Petita. Una aula, un mestre i molt de soroll.' },
          { t: 'I de pujada a l’anar i al tornar?', reply: 'Ha ha! Quin nen més espavilat. Només a l’anar. Al tornar era de baixada!' },
        ],
      },
      {
        say: 'Tinc un hortet darrere la meva garita.',
        choices: [
          { t: 'Puc ajudar-te a regar-lo algun dia?', reply: 'És clar! Als tomàquets els agrada tenir companyia.' },
          { t: 'Què hi plantes?', reply: 'Tomàquets, alfàbrega i una carbassa molt tossuda.' },
          { t: 'Les plantes també vigilen la porta?', reply: 'Ha ha! La carbassa és la meva ajudant.' },
        ],
      },
      {
        say: 'Recorda: si un desconegut et demana que vagis amb ell, digues que no i vine a buscar-me.',
        choices: [
          { t: 'Ho faré, oncle Chun.', reply: 'Molt bé. La seguretat, sempre primer.' },
          { t: 'I si diu que coneix la meva mare?', reply: 'Digues que no igualment. La teva família mai no t’enviaria un desconegut sense avisar-te.' },
          { t: 'Faré una postura de kàrate i fugiré corrents.', reply: 'Amb la part de fugir corrents ja n’hi ha prou!' },
        ],
      },
    ],
  },
  librarian: {
    greet: {
      morning: ['Bon dia, rei.', 'Ah, un lector matiner!'],
      afternoon: ['Hola. Busques alguna cosa especial?', 'Benvingut de nou.'],
      evening: ['Tanquem aviat, però no tinguis pressa.', 'Última oportunitat per agafar llibres avui!'],
    },
    topics: [
      {
        say: 'Cada llibre és una porta a un altre món.',
        choices: [
          { t: 'Quina porta hauria d’obrir ara?', reply: 'Prova un llibre sobre l’oceà. Mai més no veuràs els peixos igual.' },
          { t: 'Quin va ser el seu primer llibre preferit?', reply: 'Un llibre sobre una ratolineta molt valenta. El vaig llegir trenta vegades.' },
          { t: 'Té algun llibre sobre portes?', reply: 'Ha! Doncs… sí. Arquitectura, prestatge dotze.' },
        ],
      },
      {
        say: 'Si us plau, tracta amb cura els llibres antics. Són més vells que jo!',
        choices: [
          { t: 'Aniré amb compte, t’ho prometo.', reply: 'Gràcies. Els llibres recorden qui els tracta bé.' },
          { t: 'Quants anys té el més antic?', reply: 'Més de vuitanta! És un diccionari amb les pàgines molt primes.' },
          { t: 'Més vells que vostè? Impossible!', reply: 'Ai, quin afalagador. Au, vés a llegir alguna cosa!' },
        ],
      },
    ],
  },
  coach: {
    greet: {
      morning: ['Bon dia! Primer, estiraments!', 'Amunt, campió!'],
      afternoon: ['Ei! Fem una volta corrent?', 'Mantingues aquesta energia!'],
      evening: ['Fes la tornada a la calma i cap a casa.', 'Bon esforç avui!'],
    },
    topics: [
      {
        say: 'L’esport no va de guanyar. Va de millorar una miqueta cada dia.',
        choices: [
          { t: 'Cada dia faré tot el que pugui.', reply: 'Així m’agrada! Passos petits, grans resultats.' },
          { t: 'Com puc ser més ràpid?', reply: 'Dorm bé, menja bé i practica les sortides. Surt com un coet!' },
          { t: 'Puc millorar fent la migdiada?', reply: 'Ha! El descans forma part de l’entrenament. Però només després de practicar.' },
        ],
      },
      {
        say: 'Beu aigua abans de tenir set. El teu cos t’ho agrairà.',
        choices: [
          { t: 'Entesos, entrenador!', reply: 'Molt bé. Hidratar-se és un superpoder.' },
          { t: 'Quanta aigua he de beure?', reply: 'Un got cada hora, més o menys, quan fas activitat.' },
          { t: 'El bubble tea compta?', reply: 'Bon intent. Primer, aigua!' },
        ],
      },
    ],
  },
  clerk: {
    greet: {
      morning: ['Bon dia! Avui hi ha pa acabat de fer.', 'Hola! Compres d’hora?'],
      afternoon: ['Benvingut! Et puc ajudar en alguna cosa?', 'Hola de nou!'],
      evening: ['Bon vespre! Ara les boles d’arròs són a meitat de preu.', 'Dia llarg? Agafa’t un piscolabis.'],
    },
    topics: [
      {
        say: 'Sabies que la botiga obre fins a les onze?',
        choices: [
          { t: 'Quin torn més llarg! Gràcies per treballar tant.', reply: 'Ai, gràcies. Amb clients com tu és fàcil.' },
          { t: 'Què és el que es ven més?', reply: 'Els ous al te! La gent en compra dotzenes cada dia.' },
          { t: 'Dorms darrere el taulell?', reply: 'Ha ha, només en somnis!' },
        ],
      },
      {
        say: 'Estic estalviant per obrir la meva pròpia cafeteria algun dia.',
        choices: [
          { t: 'Ho aconseguiràs! Jo seré el teu primer client.', reply: 'Tracte fet! La primera tassa de cacau, convida la casa.' },
          { t: 'Com l’anomenaries?', reply: '«Cafè El Fanalet». Acollidora i plena de plantes.' },
          { t: 'Hi haurà galetes gratis?', reply: 'Per al meu primer client? És clar!' },
        ],
      },
    ],
  },
  grandma: {
    greet: {
      morning: ['Bon dia, petitó.', 'Quin matí més fresc, oi?'],
      afternoon: ['Vine a seure amb mi una estona.', 'Avui els coloms tenen gana.'],
      evening: ['Aviat serà hora de tornar a casa.', 'Mira que rosa que està el cel.'],
    },
    topics: [
      {
        say: 'Quan jo era jove, aquest parc eren tot arrossars.',
        choices: [
          { t: 'Devia ser preciós.', reply: 'Ho era. Verd fins on arribava la vista, i granotes cantant a la nit.' },
          { t: 'Què fèieu per divertir-vos?', reply: 'Atrapàvem cuques de llum en pots i després les deixàvem anar.' },
          { t: 'Els coloms també vivien aquí?', reply: 'Ha! Els seus rebesavis, potser!' },
        ],
      },
      {
        say: 'Truques sovint als teus avis?',
        choices: [
          { t: 'Els hauria de trucar més. Ho faré!', reply: 'Estaran tan contents… Una trucada curta val molt.' },
          { t: 'Què els agrada sentir, als avis?', reply: 'Què has menjat, què has après i que estàs content.' },
          { t: 'Els envio adhesius!', reply: 'Els adhesius estan bé. Però una veu encara és més bonica.' },
        ],
      },
    ],
  },
  bo: {
    greet: {
      morning: ['Hola! Vols jugar?', 'Mira! He trobat una pedra que brilla!'],
      afternoon: ['T’he tocat! Ara pares tu! …És broma.', 'Sóc un dinosaure! GRAAAU!'],
      evening: ['La mama diu que he de tornar a casa aviat…', 'No tinc son! *badall*'],
    },
    topics: [
      {
        say: 'Quan sigui gran vull ser astronauta!',
        choices: [
          { t: 'Seràs un astronauta genial!', reply: 'Sí! Et saludaré des de la lluna!' },
          { t: 'Què faràs a l’espai?', reply: 'Surar! I menjar gelat d’astronauta!' },
          { t: 'M’hi portaràs?', reply: 'Només si portes berenar!' },
        ],
      },
      {
        say: 'Saps algun acudit?',
        choices: [
          { t: 'Què fa una vaca amb els ulls tancats? Llet concentrada!', reply: 'Ha ha ha! No l’entenc, però fa gràcia!' },
          { t: 'I TU, en saps algun?', reply: 'Què té quatre potes i fa «buuu»? …Una vaca refredada! Ha ha ha!' },
          { t: 'Toc, toc.', reply: 'Qui hi ha? …Espera, ho vull fer jo!' },
        ],
      },
    ],
  },
  mom: {
    greet: {
      morning: ['Bon dia, carinyo. L’esmorzar ja és a taula.', 'Bon dia! Ho portes tot a la motxilla?'],
      afternoon: ['Hola, amor. Com ha anat el dia?', 'Ja ets a casa! Renta’t les mans.'],
      evening: ['El sopar serà a punt aviat.', 'Aquesta nit no et quedis despert fins tard.'],
    },
    topics: [
      {
        say: 'Avui ha passat res difícil que en vulguis parlar?',
        choices: [
          { t: 'Un amic estava trist. He intentat ajudar-lo.', reply: 'Que bonic. Només escoltar ja és una gran ajuda, saps?' },
          { t: 'Com ho fas tu, els dies difícils, Mama?', reply: 'Em faig un te, respiro fondo i recordo que demà és un dia nou.' },
          { t: 'El més difícil ha estat esperar el sopar.', reply: 'Ha ha! Va, va, que ja gairebé és a punt.' },
        ],
      },
      {
        say: 'Què cuinem aquest cap de setmana?',
        choices: [
          { t: 'Fem dumplings junts!', reply: 'Sí! Tu els tanques i jo faig el farcit.' },
          { t: 'M’ensenyes la teva recepta de sopa?', reply: 'És clar. Me la va ensenyar l’àvia, i ara te l’ensenyo a tu.' },
          { t: 'Pastís per sopar?', reply: 'Pastís de postres. Verdura per sopar!' },
        ],
      },
      {
        say: 'Estic orgullosa de com t’estàs tornant tan responsable.',
        choices: [
          { t: 'Gràcies, Mama. Ho he après de tu.', reply: 'Ai, que em faràs plorar. Vine aquí!' },
          { t: 'Què t’ha fet sentir orgullosa avui?', reply: 'Que has ajudat sense que t’ho demanés. Això val molt.' },
          { t: 'Prou orgullosa per a una mica més de setmanada?', reply: 'Ha ha, bon intent! Orgullosa, sí. Rica, no.' },
        ],
      },
    ],
  },
  sister: {
    greet: {
      morning: ['Desperta’t! Juga amb mi!', 'He dibuixat un gat! Mira!'],
      afternoon: ['Ja ets a casa! Visca!', 'Fem un trencaclosques?'],
      evening: ['Em llegeixes un conte?', 'No tinc son… *badall*'],
    },
    topics: [
      {
        say: 'La lluna segueix el nostre cotxe?',
        choices: [
          { t: 'Sembla que sí! Et vol saludar.', reply: 'Hola, lluna! Hi hi!' },
          { t: 'És molt lluny, per això sembla que ens segueix.', reply: 'Ooh… Llavors segueix tothom alhora?' },
          { t: 'Sí. És una lluna molt xafardera.', reply: 'Lluna xafardera! Ha ha ha!' },
        ],
      },
      {
        say: 'He tingut un malson amb un monstre.',
        choices: [
          { t: 'Sóc aquí. Estàs segura.', reply: 'D’acord… Pots deixar la porta una mica oberta?' },
          { t: 'Com era el monstre?', reply: 'Gran i peludet… de fet era una mica bufó.' },
          { t: 'El combatré amb un coixí!', reply: 'Guerra de coixins! Guerra de coixins!' },
        ],
      },
    ],
  },
  dad: {
    greet: {
      morning: ['Bon dia, campió.', 'Bon dia! Primer, el cafè.'],
      afternoon: ['Ei, què tal!', 'Com està el meu fill preferit?'],
      evening: ['Uf, quin dia més llarg. Vine a seure amb mi.', 'Aquesta nit sopem tots junts!'],
    },
    topics: [
      {
        say: 'Perdona que de vegades treballi fins tan tard.',
        choices: [
          { t: 'No passa res. M’agrada quan mengem junts.', reply: 'A mi també. Intentaré venir d’hora més sovint.' },
          { t: 'Què fas tot el dia a la feina?', reply: 'Moltes reunions i fulls de càlcul. No és tan emocionant com l’institut!' },
          { t: 'Em deus una nit de jocs!', reply: 'Tracte fet! Dissabte, jocs de taula i sense mòbils.' },
        ],
      },
      {
        say: 'Vols sentir un acudit de pare?',
        choices: [
          { t: 'Endavant, Papa.', reply: 'Què li diu un ou a un altre ou? Ens hem de veure més sovint, que ens estem fent malbé!' },
          { t: 'Només si fa gràcia de debò.', reply: 'Com es diu un dinosaure que dorm? Un dino-ronc!' },
          { t: 'Si us plau, no!', reply: 'Massa tard! Per què l’espantaocells va guanyar un premi? Perquè era el millor del seu camp!' },
        ],
      },
    ],
  },
  xiaoyu: {
    greet: {
      morning: ['…Hola.', 'Ah. Bon dia.'],
      afternoon: ['Ei.', 'Hola… gràcies per abans.'],
      evening: ['Hauria d’anar cap a casa.', 'Ha estat un dia normalet.'],
    },
    topics: [
      {
        say: 'M’agrada dibuixar. M’ajuda quan tinc el cap ple de soroll.',
        choices: [
          { t: 'És una manera genial de sentir-se millor.', reply: 'Sí. Potser algun dia t’ensenyaré alguns dibuixos.' },
          { t: 'Què t’agrada dibuixar?', reply: 'Robots. I de vegades el meu gos.' },
          { t: 'Em dibuixes com un superheroi?', reply: '…D’acord. Ha ha. Amb capa.' },
        ],
      },
      {
        say: 'Mai no et sents cansat de tot?',
        choices: [
          { t: 'De vegades. Parlar amb algú ajuda.', reply: 'Sí… Parlar amb tu ajuda una mica.' },
          { t: 'Què és el que et cansa?', reply: 'A casa hi ha molt de soroll. Però la sala d’orientació és tranquil·la.' },
          { t: 'Anem a prendre un cacau.', reply: 'Un cacau sona bé, la veritat.' },
        ],
      },
    ],
  },
};
